import { render, staticRenderFns } from "./bestandsübersicht.vue?vue&type=template&id=4cf810bc&scoped=true&"
import script from "./bestandsübersicht.vue?vue&type=script&lang=js&"
export * from "./bestandsübersicht.vue?vue&type=script&lang=js&"
import style0 from "./bestandsübersicht.vue?vue&type=style&index=0&id=4cf810bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf810bc",
  null
  
)

export default component.exports